<template>
  <LocalFileUploaderModal
    :modalTitle="$i18nPresenter.t('Import slides')"
    :isModalVisible="isModalVisible"
    :staticState="staticState"
    :uploadingState="isUploadingFile"
    :uploadError="aiChatbotImportSlidesError"
    :needGenerateQuiz="needGenerateQuiz"
    :featureName="UploadFeatureName.AI_CHATBOT_IMPORT"
    :instructionText="instructionText"
    :separateFormatterFromUpload="true"
    @hide="hide()"
  >
    <template #footerSection>
      <div class="flex justify-between items-center mt-3">
        <!-- Import options -->
        <div>
          <div v-for="option in importOptions" :key="option">
            <aha-radio
              class="mb-2"
              :value="option"
              @change="onChangeImportOption(option)"
              v-aha-emit-action="{'importOption': option}"
              name="ai-chatbot-import-modal-option"
            >
              {{ $i18nPresenter.t(option) }}
            </aha-radio>
          </div>
        </div>

        <!-- Go button -->
        <aha-button
          v-aha-emit-action="{'importOption': selectedImportOption}"
          name="ai-chatbot-import-modal-go-button"
          :disabled="!selectedImportOption || !aiChatbotUploadedFile || isUploadingFile"
          type="submit"
          @click="onGoButtonClick"
        >
          {{ $i18nPresenter.t('Go') }}
        </aha-button>
      </div>
    </template>
  </LocalFileUploaderModal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import UploadFeatureName from '@/constant/uploadFeatureName'

// components
import LocalFileUploaderModal from '@/components-v2/modals/LocalFileUploaderModal.vue'

const IMPORT_OPTIONS = {
  IMPORT_ONLY: 'Import slides',
  IMPORT_AND_GENERATE: 'Import and generate interactive slides',
}

export default {
  components: {
    LocalFileUploaderModal,
  },
  data() {
    return {
      isModalVisible: false,
      selectedImportOption: '',
      importOptions: Object.values(IMPORT_OPTIONS),
      needGenerateQuiz: false,
      UploadFeatureName,
      IMPORT_OPTIONS,
    }
  },
  computed: {
    ...mapState({
      presentationId: (state) => state.presentation?.id,
    }),

    ...mapGetters('aiChatbotImportPptxPdf', [
      'aiChatbotImportSlidesError',
      'aiChatbotUploadedFile',
      'isUploadingFile',
      'sourceFile',
      'canUseAIChatbotImportGenerateSlides',
    ]),
    ...mapGetters('rightNav', ['isAITabActive']),

    staticState() {
      return !this.isUploadingFile
    },

    instructionText() {
      return this.$i18nPresenter.t('Upload a PDF, PPT or PPTX file. Up to 50MB and 100 slides.')
    },
  },
  mounted() {
    this.show()
    this.setAIChatbotImportSlidesErrorAction('')
    this.setSourceFileAction(null)
    this.setAIChatbotUploadedFileAction(null)
  },
  methods: {
    ...mapActions('aiChatbotImportPptxPdf', [
      'setIsAIChatbotImportModalVisibleAction',
      'importSlidesAction',
      'setAIChatbotImportSlidesErrorAction',
      'setSourceFileAction',
      'setAIChatbotUploadedFileAction',
      'sendImportDataToAIChatbotAction',
    ]),
    ...mapActions('rightNav', ['openAIPanelAction']),
    ...mapActions('docToSlideGenerator', ['docToSlideUploadFileAction']),

    show() {
      this.isModalVisible = true
    },

    hide() {
      this.$emit('hide')
      this.setIsAIChatbotImportModalVisibleAction(false)
    },

    onChangeImportOption(option) {
      this.selectedImportOption = option
      if (option === this.IMPORT_OPTIONS.IMPORT_ONLY) return

      this.needGenerateQuiz = true
    },

    _handleImportAndGenerateSlides() {
      if (this.canUseAIChatbotImportGenerateSlides) {
        this.sendImportDataToAIChatbotAction(
          { importOption: this.selectedImportOption },
        )

        if (!this.isAITabActive) {
          this.openAIPanelAction()
        }
      } else {
        this.docToSlideUploadFileAction(this.sourceFile)
      }
    },

    onGoButtonClick() {
      if (this.selectedImportOption === this.IMPORT_OPTIONS.IMPORT_AND_GENERATE) {
        this._handleImportAndGenerateSlides()
      } else {
        this.importSlidesAction({
          presentationId: this.presentationId,
          fileHashId: this.aiChatbotUploadedFile?.hash_id,
        })
      }

      this.hide()
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
